import React, { useState } from "react";
import {
  Container,
  StagesMobile,
  StagesDesktop,
  Left,
  Right,
  Description,
  Label,
  ProgressBar,
  Icon,
  Tooltip,
  ModalContainer,
  Close,
} from "./styles";
import { Icon21 as Icon26 } from "../../assets/todeschini";
import { closeIcon } from "../../assets/todeschini";
import { IStartJourneyResponse } from "../../types/IStartJourneyResponse";
import can from "../../utils/can";

interface IProps {
  theme?: IStartJourneyResponse;
}

interface IModalProps {
  url?: string;
  texts?: {
    stage?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
  };
  modalVisibilityControl: (state: boolean) => void;
}

const Modal: React.FC<IModalProps> = ({
  url,
  texts,
  modalVisibilityControl,
}) => {
  return (
    <ModalContainer url={url}>
      <div className="modal">
        {url && (
          <div className="video">
            <div
              dangerouslySetInnerHTML={{
                __html: `<iframe src='${url}' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen />`,
              }}
            />
          </div>
        )}
        <div className="info">
          <div className="etapa">{texts?.stage}</div>
          <div className="nome">{texts?.name}</div>
          <div className="descricao">{texts?.description}</div>
        </div>
        <Close>
          <img src={closeIcon} onClick={() => modalVisibilityControl(false)} />
        </Close>
      </div>
    </ModalContainer>
  );
};

interface GH {
  name: string | undefined;
  description: string | undefined;
  stage: string | undefined;
}

const Stages: React.FC<IProps> = ({ theme }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [modalVideoUrl, setModalVideoUrl] = useState<string>();
  const [modalTexts, setModalTexts] = useState<GH>({
    name: "",
    description: "",
    stage: "",
  });

  return (
    <Container>
      <StagesMobile>
        <Left>
          <Label>Etapa 1</Label>
          <Label>Etapa 2</Label>
          <Label>Etapa 3</Label>
          <Label>Etapa 4</Label>
          <Label>Etapa 5</Label>
        </Left>

        <ProgressBar>
          <div className="dot" />
          <hr />
          <div className="dot" />
          <hr />
          <div className="dot" />
          <hr />
          <div className="dot" />
          <hr />
          <div className="dot" />
        </ProgressBar>

        <Right>
          <Description>
            <Icon
              onClick={() => {
                setIsModalVisible((prevState) => !prevState);
                setModalTexts({
                  name: theme?.steps.etapa_timeline_informativa.propriedades
                    .conteudo.timeline.nome_etapa_1,
                  description:
                    theme?.steps.etapa_timeline_informativa.propriedades
                      .conteudo.timeline.descricao_etapa_1,
                  stage: "ETAPA 1",
                });
                setModalVideoUrl(
                  can(
                    theme,
                    "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.url_etapa_1"
                  )
                );
              }}
            >
              <img
                src={can(
                  theme,
                  "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.icone_etapa_1"
                )}
                alt=""
              />
            </Icon>
            {isModalVisible && (
              <Modal
                url={modalVideoUrl}
                texts={modalTexts}
                modalVisibilityControl={(props) => {
                  setIsModalVisible(props);
                }}
              />
            )}
            <div>
              <span className="description">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.nome_etapa_1
                }
              </span>
              <span className="title">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.local_etapa_1
                }
              </span>
            </div>
          </Description>

          <Description>
            <Icon
              onClick={() => {
                setIsModalVisible((prevState) => !prevState);
                setModalTexts({
                  name: theme?.steps.etapa_timeline_informativa.propriedades
                    .conteudo.timeline.nome_etapa_4,
                  description:
                    theme?.steps.etapa_timeline_informativa.propriedades
                      .conteudo.timeline.descricao_etapa_4,
                  stage: "ETAPA 2",
                });
                setModalVideoUrl(
                  can(
                    theme,
                    "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.url_etapa_4"
                  )
                );
              }}
            >
              <img
                src={can(
                  theme,
                  "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.icone_etapa_2"
                )}
                alt=""
              />
            </Icon>
            <div>
              <span className="description">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.nome_etapa_2
                }
              </span>
              <span className="title">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.local_etapa_2
                }
              </span>
            </div>
          </Description>

          <Description>
            <Icon
              onClick={() => {
                setIsModalVisible((prevState) => !prevState);
                setModalTexts({
                  name: theme?.steps.etapa_timeline_informativa.propriedades
                    .conteudo.timeline.nome_etapa_3,
                  description:
                    theme?.steps.etapa_timeline_informativa.propriedades
                      .conteudo.timeline.descricao_etapa_3,
                  stage: "ETAPA 3",
                });
                setModalVideoUrl(
                  can(
                    theme,
                    "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.url_etapa_3"
                  )
                );
              }}
            >
              <img
                src={can(
                  theme,
                  "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.icone_etapa_3"
                )}
                alt=""
              />
            </Icon>
            <div>
              <span className="description">
                {can(
                  theme,
                  "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.nome_etapa_3"
                )}
              </span>
              <span className="title">
                {can(
                  theme,
                  "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.local_etapa_3"
                )}
              </span>
            </div>
          </Description>

          <Description>
            <Icon
              onClick={() => {
                setIsModalVisible((prevState) => !prevState);
                setModalTexts({
                  name: theme?.steps.etapa_timeline_informativa.propriedades
                    .conteudo.timeline.nome_etapa_4,
                  description:
                    theme?.steps.etapa_timeline_informativa.propriedades
                      .conteudo.timeline.descricao_etapa_4,
                  stage: "ETAPA 4",
                });
                setModalVideoUrl(
                  can(
                    theme,
                    "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.url_etapa_4"
                  )
                );
              }}
            >
              <img
                src={can(
                  theme,
                  "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.icone_etapa_4"
                )}
                alt=""
              />
            </Icon>
            <div>
              <span className="description">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.nome_etapa_4
                }
              </span>
              <span className="title">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.local_etapa_4
                }
              </span>
            </div>
          </Description>

          <Description>
            <Icon
              onClick={() => {
                setIsModalVisible((prevState) => !prevState);
                setModalTexts({
                  name: theme?.steps.etapa_timeline_informativa.propriedades
                    .conteudo.timeline.nome_etapa_5,
                  description:
                    theme?.steps.etapa_timeline_informativa.propriedades
                      .conteudo.timeline.descricao_etapa_5,
                  stage: "ETAPA 5",
                });
                setModalVideoUrl(
                  can(
                    theme,
                    "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.url_etapa_5"
                  )
                );
              }}
            >
              <img
                src={can(
                  theme,
                  "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.icone_etapa_5"
                )}
                alt=""
              />
            </Icon>
            <div>
              <span className="description">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.nome_etapa_5
                }
              </span>
              <span className="title">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.local_etapa_5
                }
              </span>
            </div>
          </Description>
        </Right>
      </StagesMobile>

      <StagesDesktop>
        <Left>
          <Label>Etapa 1</Label>

          <Description isLeft>
            <div>
              <span className="description">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.nome_etapa_2
                }
              </span>
              <span className="title">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.local_etapa_2
                }
              </span>
            </div>
            <Icon
              onClick={() => {
                setIsModalVisible((prevState) => !prevState);
                setModalTexts({
                  name: theme?.steps.etapa_timeline_informativa.propriedades
                    .conteudo.timeline.nome_etapa_2,
                  description:
                    theme?.steps.etapa_timeline_informativa.propriedades
                      .conteudo.timeline.descricao_etapa_2,
                  stage: "ETAPA 2",
                });
                setModalVideoUrl(
                  can(
                    theme,
                    "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.url_etapa_2"
                  )
                );
              }}
            >
              <img
                src={can(
                  theme,
                  "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.icone_etapa_2"
                )}
                alt=""
              />
            </Icon>
          </Description>

          <Label>Etapa 3</Label>

          <Description isLeft>
            <div>
              <span className="description">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.nome_etapa_4
                }
              </span>
              <span className="title">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.local_etapa_4
                }
              </span>
            </div>
            <Icon
              onClick={() => {
                setIsModalVisible((prevState) => !prevState);
                setModalTexts({
                  name: theme?.steps.etapa_timeline_informativa.propriedades
                    .conteudo.timeline.nome_etapa_4,
                  description:
                    theme?.steps.etapa_timeline_informativa.propriedades
                      .conteudo.timeline.descricao_etapa_4,
                  stage: "ETAPA 4",
                });
                setModalVideoUrl(
                  can(
                    theme,
                    "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.url_etapa_4"
                  )
                );
              }}
            >
              <img
                src={can(
                  theme,
                  "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.icone_etapa_4"
                )}
                alt=""
              />
            </Icon>
          </Description>

          <Label>Etapa 5</Label>
        </Left>

        <ProgressBar>
          <div className="dot" />
          <hr />
          <div className="dot" />
          <hr />
          <div className="dot" />
          <hr />
          <div className="dot" />
          <hr />
          <div className="dot" />
        </ProgressBar>

        <Right>
          <Tooltip>
            <img src={Icon26} alt="" /> <div>Nós estamos aqui</div>
          </Tooltip>
          <Description>
            <Icon
              onClick={() => {
                setIsModalVisible((prevState) => !prevState);
                setModalTexts({
                  name: theme?.steps.etapa_timeline_informativa.propriedades
                    .conteudo.timeline.nome_etapa_1,
                  description:
                    theme?.steps.etapa_timeline_informativa.propriedades
                      .conteudo.timeline.descricao_etapa_1,
                  stage: "ETAPA 1",
                });
                setModalVideoUrl(
                  can(
                    theme,
                    "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.url_etapa_1"
                  )
                );
              }}
            >
              <img
                src={can(
                  theme,
                  "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.icone_etapa_1"
                )}
                alt=""
              />
            </Icon>
            {isModalVisible && (
              <Modal
                url={modalVideoUrl}
                texts={modalTexts}
                modalVisibilityControl={(props) => {
                  setIsModalVisible(props);
                }}
              />
            )}
            <div>
              <span className="description">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.nome_etapa_1
                }
              </span>
              <span className="title">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.local_etapa_1
                }
              </span>
            </div>
          </Description>

          <Label>Etapa 2</Label>

          <Description>
            <Icon
              onClick={() => {
                setIsModalVisible((prevState) => !prevState);
                setModalTexts({
                  name: theme?.steps.etapa_timeline_informativa.propriedades
                    .conteudo.timeline.nome_etapa_3,
                  description:
                    theme?.steps.etapa_timeline_informativa.propriedades
                      .conteudo.timeline.descricao_etapa_3,
                  stage: "ETAPA 3",
                });
                setModalVideoUrl(
                  can(
                    theme,
                    "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.url_etapa_3"
                  )
                );
              }}
            >
              <img
                src={can(
                  theme,
                  "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.icone_etapa_3"
                )}
                alt=""
              />
            </Icon>
            <div>
              <span className="description">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.nome_etapa_3
                }
              </span>
              <span className="title">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.local_etapa_3
                }
              </span>
            </div>
          </Description>

          <Label>Etapa 4</Label>

          <Description>
            <Icon
              onClick={() => {
                setIsModalVisible((prevState) => !prevState);
                setModalTexts({
                  name: theme?.steps.etapa_timeline_informativa.propriedades
                    .conteudo.timeline.nome_etapa_5,
                  description:
                    theme?.steps.etapa_timeline_informativa.propriedades
                      .conteudo.timeline.descricao_etapa_5,
                  stage: "ETAPA 5",
                });
                setModalVideoUrl(
                  can(
                    theme,
                    "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.url_etapa_5"
                  )
                );
              }}
            >
              <img
                src={can(
                  theme,
                  "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.icone_etapa_5"
                )}
                alt=""
              />
            </Icon>
            <div>
              <span className="description">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.nome_etapa_5
                }
              </span>
              <span className="title">
                {
                  theme?.steps.etapa_timeline_informativa.propriedades.conteudo
                    .timeline.local_etapa_5
                }
              </span>
            </div>
          </Description>
        </Right>
      </StagesDesktop>
    </Container>
  );
};

export default Stages;
